"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingUserListComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const console_1 = require("@rws-framework/console");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const component_2 = require("@front/layouts/default-layout/component");
const acl_helpers_1 = require("@back/app/acl_module/acl.helpers");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="dashboard-wrapper">
        <div class="firms-list row">
            <div class="form col-12 pb-lg-5">

                <div class="mb-2">
                    <h1>${'onboarding.title'.t()}</h1>
                </div>

                
                <div class="mb-3">
                    <div class="row">

                        <div class="col-lg-7">
                            <div class="card p-4">
                                <div class="row">
                                    <div class="col-lg-7">
                                        <div class="d-flex flex-wrap gap-1 h-100">
                                            <div class="d-flex gap-3">
                                                <div class="py-2" style="font-size:55px; margin-left:-16px;">
                                                    <i class="iconsminds-profile"></i>
                                                </div>
                                                <div>
                                                    <h1 class="m-0">${'onboarding.intro.start'.t()}</h1>
                                                    <h3>${'onboarding.intro.optimize'.t()}</h3>
                                                </div>
                                            </div>

                                            <p>${'onboarding.intro.moment'.t()}</p>
                                            <p>${'onboarding.intro.enables'.t()}</p>
                                            <ul>
                                                <li>${'onboarding.benefits.precise_interactions'.t()}</li>
                                                <li>${'onboarding.benefits.customer_satisfaction'.t()}</li>
                                                <li>${'onboarding.benefits.workflow_automation'.t()}</li>
                                                <li>${'onboarding.benefits.real_time_insights'.t()}</li>
                                            </ul>

                                            <button class="mt-auto btn btn-primary btn-lg"
                                                @click="${x => x.startOnboarding()}">
                                                ${'onboarding.button.start'.t()}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-lg-5">
                                        <img src="/assets/images/avatar-big.png" class="card"
                                            style="width:100%; min-height:500px; margin-top:-80px; object-fit: cover;"
                                            alt="${'onboarding.image.alt'.t()}">
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                        <div class="col-lg-5">
                            <div class="">
                                <rws-accordion accordionId="aiOnboardingFAQ" :headers="${x => x.faqHeaders}" :externalExpandedItems="${x => x.faqExpandedItems}">

                                    
                                    <div slot="content-faq-0">
                                        <p class="answer-intro">${'onboarding.faq.answer1.intro'.t()}</p>
                                        <ul class="answer-list">
                                            <li class="answer-item">${'onboarding.faq.answer1.role1'.t()}</li>
                                            <li class="answer-item">${'onboarding.faq.answer1.role2'.t()}</li>
                                            <li class="answer-item">${'onboarding.faq.answer1.role3'.t()}</li>
                                            <li class="answer-item">${'onboarding.faq.answer1.role4'.t()}</li>
                                        </ul>
                                    </div>

                                    
                                    <div slot="content-faq-1">
                                        <p class="answer-intro">${'onboarding.faq.answer2.intro'.t()}</p>
                                        <ul class="answer-list">
                                            <li class="answer-item">${'onboarding.faq.answer2.step1'.t()}</li>
                                            <li class="answer-item">${'onboarding.faq.answer2.step2'.t()}</li>
                                            <li class="answer-item">${'onboarding.faq.answer2.step3'.t()}</li>
                                        </ul>
                                    </div>

                                    
                                    <div slot="content-faq-2">
                                        <p class="answer-intro">${'onboarding.faq.answer3.intro'.t()}</p>
                                        <ul class="answer-list">
                                            <li class="answer-item">${'onboarding.faq.answer3.goal1'.t()}</li>
                                            <li class="answer-item">${'onboarding.faq.answer3.goal2'.t()}</li>
                                            <li class="answer-item">${'onboarding.faq.answer3.goal3'.t()}</li>
                                        </ul>
                                    </div>

                                    
                                    <div slot="content-faq-3">
                                        <p class="answer-intro">${'onboarding.faq.answer4.intro'.t()}</p>
                                        <ul class="answer-list">
                                            <li class="answer-item">${'onboarding.faq.answer4.reason1'.t()}</li>
                                            <li class="answer-item">${'onboarding.faq.answer4.reason2'.t()}</li>
                                        </ul>
                                        <p class="answer-conclusion">${'onboarding.faq.answer4.conclusion'.t()}</p>
                                    </div>

                                </rws-accordion>
                            </div>
                        </div>
                    </div>
                    
                </div>

                
                <div class="mb-5">
                    <div class="row">
                        <div class="col-12">
                            <div class="card p-4">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h5><i class="fas fa-list mr-2"></i>${'onboarding.list.records'.t()}</h5>
                                    <button @click="${x => x.navigateToAdd()}" class="btn btn-primary" ?hidden="${x => !x.canAdd}">
                                        <i class="fas fa-plus mr-2"></i>${'onboarding.create'.t()}
                                    </button>
                                </div>

                                <div class="table-responsive">
                                    <table class="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>${'onboarding.status'.t()}</th>
                                                <th>${'onboarding.profession'.t()}</th>
                                                <th>${'onboarding.avatar.name'.t()}</th>
                                                <th>${'onboarding.currentStep'.t()}</th>
                                                <th>${'onboarding.progress'.t()}</th>
                                                <th>${'onboarding.knowledge.items'.t()}</th>
                                                <th>${'onboarding.createdBy'.t()}</th>
                                                <th>${'onboarding.createdAt'.t()}</th>
                                                <th>${'actions'.t()}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${(0, fast_element_1.repeat)(x => x.onboardingRecords, (0, fast_element_1.html) `
                                            <tr>
                                                <td>
                                                    ${(0, fast_element_1.when)(x => x.status === 'completed', (0, fast_element_1.html) `
                                                    <span
                                                        class="badge badge-success">${'onboarding.status.completed'.t()}</span>
                                                    `)}
                                                    ${(0, fast_element_1.when)(x => x.status === 'in_progress', (0, fast_element_1.html) `
                                                    <span
                                                        class="badge badge-warning">${'onboarding.status.in_progress'.t()}</span>
                                                    `)}
                                                    ${(0, fast_element_1.when)(x => x.status === 'abandoned', (0, fast_element_1.html) `
                                                    <span
                                                        class="badge badge-danger">${'onboarding.status.abandoned'.t()}</span>
                                                    `)}
                                                    ${(0, fast_element_1.when)(x => !x.status || (x.status !== 'completed' && x.status !==
    'in_progress' && x.status !== 'abandoned'), (0, fast_element_1.html) `
                                                    <span class="badge badge-secondary">${x => x.status ||
    'onboarding.status.unknown'.t()}</span>
                                                    `)}
                                                </td>
                                                <td>${x => x.profession ? x.profession.name : '-'}</td>
                                                <td>
                                                    ${(0, fast_element_1.when)(x => x.avatar && x.avatar.name, (0, fast_element_1.html) `
                                                    <a class="avatar-link" @click="${(x, c) => c.parent.goToAvatar.bind(c.parent)(x.avatar.id, c.event)}" href="/avatar/preview/${x => x.avatar.id}">${x => x.avatar.name}</a>
                                                    `, '-')}
                                                </td>
                                                <td>${x => x.currentStep || '-'}</td>
                                                <td>
                                                    <div class="progress" style="height: 20px;">
                                                        <div class="progress-bar" role="progressbar"
                                                            :style="${(x, c) => 'width: ' + c.parent.getProgressPercentage(x) + '%'}"
                                                            :aria-valuenow="${(x, c) => c.parent.getProgressPercentage(x)}"
                                                            aria-valuemin="0" aria-valuemax="100">
                                                            ${(x, c) => c.parent.getProgressPercentage(x)}%
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info">${x => x.knowledge_ids && x.knowledge_ids.length ||
    0}</span>
                                                </td>
                                                <td>
                                                    ${(0, fast_element_1.when)(x => x.user, (0, fast_element_1.html) `
                                                    <span class="badge badge-success">
                                                        ${x => x.user.name}
                                                    </span>
                                                    `)}
                                                    ${(0, fast_element_1.when)(x => !x.user, (0, fast_element_1.html) `
                                                    <span class="text-muted">-</span>
                                                    `)}
                                                </td>
                                                <td>
                                                    ${(record, c) => c.parent.formatDate(record.created_at, 'yyyy-MM-dd')}<br />
                                                    <small class="text-muted"> ${(record, c) => c.parent.formatDate(record.created_at, 'HH:mm:ss')}</small>
                                                </td>
                                                <td>
                                                    <div class="btn-group actions-container" role="group">
                                                        <rws-tooltip side="left" text="${'onboarding.tooltip.view'.t()}">
                                                            <button class="btn btn-outline-primary btn-sm"
                                                                @click="${(record, c) => c.parent.viewRecord(record.id)}">
                                                                <i class="simple-icon-eye"></i>
                                                            </button>
                                                        </rws-tooltip>
                                                        ${(0, fast_element_1.when)((record, c) => c.parent.canEdit(record), (0, fast_element_1.html) `<rws-tooltip side="left" text="${'onboarding.tooltip.edit'.t()}">
                                                            <button class="btn btn-outline-warning btn-sm"
                                                                @click="${(record, c) => c.parent.editRecord(record.id)}">
                                                                <i class="simple-icon-pencil"></i>
                                                            </button>
                                                        </rws-tooltip>`)}
                                                        ${(0, fast_element_1.when)((record, c) => c.parent.canDelete(record), (0, fast_element_1.html) `<rws-tooltip side="left" text="${'onboarding.tooltip.delete'.t()}">
                                                            <button class="btn btn-outline-danger btn-sm"
                                                                @click="${(record, c) => c.parent.deleteRecord(record.id)}">
                                                                <i class="simple-icon-trash"></i>
                                                            </button>
                                                        </rws-tooltip>`)}
                                                    </div>
                                                </td>
                                            </tr>
                                            `, { positioning: true })}
                                            <tr ?hidden="${x => !(x.onboardingRecords.length === 0 && !x.loading)}">
                                                <td colspan="9" class="text-center text-muted py-4">
                                                    ${'onboarding.records.empty.description'.t()}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                
                                ${(0, fast_element_1.when)(x => x.totalPages > 1, (0, fast_element_1.html) `
                                <nav aria-label="${'onboarding.list.pagination.label'.t()}" class="mt-3">
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item ${x => x.currentPage === 1 ? 'disabled' : ''}">
                                            <button class="page-link" @click="${x => x.previousPage()}"
                                                ?disabled="${x => x.currentPage === 1}">
                                                ${'pagination.previous'.t()}
                                            </button>
                                        </li>

                                        ${(0, fast_element_1.repeat)(x => x.pageNumbers, (0, fast_element_1.html) `
                                        <li class="page-item ${(x, c) => c.parent.currentPage === x ? 'active' : ''}">
                                            <button class="page-link" @click="${(x, c) => c.parent.goToPage(x)}">
                                                ${x => x}
                                            </button>
                                        </li>
                                        `)}

                                        <li class="page-item ${x => x.currentPage === x.totalPages ? 'disabled' : ''}">
                                            <button class="page-link" @click="${x => x.nextPage()}"
                                                ?disabled="${x => x.currentPage === x.totalPages}">
                                                ${'pagination.next'.t()}
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                                `)}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.dashboard-wrapper .card {
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
  border-radius: 0.5rem;
  border: 1px solid #dee2e6;
}

.user-list-page .answer-intro {
  margin-bottom: 0.75rem;
}
.user-list-page .answer-list {
  margin-bottom: 0.75rem;
}
.user-list-page .answer-list .answer-item {
  margin-bottom: 0.25rem;
}
.user-list-page .answer-conclusion {
  margin-bottom: 0;
}

.avatar-link {
  text-decoration: underline;
}`;
const shadowOptions = { "mode": "open" };
let OnboardingUserListComponent = class OnboardingUserListComponent extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.onboardingRecords = [];
        this.loading = false;
        this.canAdd = false;
        this.canEditGlobal = false;
        this.canDeleteGlobal = false;
        this.currentPage = 1;
        this.totalPages = 1;
        this.pageNumbers = [];
        this.faqHeaders = [
            { id: 'faq-0', title: 'onboarding.faq.question1'.t(), expanded: true },
            { id: 'faq-1', title: 'onboarding.faq.question2'.t() },
            { id: 'faq-2', title: 'onboarding.faq.question3'.t() },
            { id: 'faq-3', title: 'onboarding.faq.question4'.t() }
        ];
        this.faqExpandedItems = ['faq-0']; // First FAQ expanded by default
    }
    connectedCallback() {
        var _a;
        // Set up global permissions
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        this.canAdd = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`, component_2.DefaultLayout.USER.acl);
        this.canEditGlobal = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`, component_2.DefaultLayout.USER.acl);
        this.canDeleteGlobal = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.delete}`, component_2.DefaultLayout.USER.acl);
        console.log('User ACL for onboarding - Add:', this.canAdd, 'Edit global:', this.canEditGlobal, 'Delete global:', this.canDeleteGlobal);
        super.connectedCallback();
        this.loadData();
    }
    async loadData() {
        this.loading = true;
        try {
            let routeOptions = {};
            if (this.currentPage !== null) {
                routeOptions.queryParams = {
                    p: this.currentPage.toString(),
                    per_page: '20'
                };
            }
            const response = await this.apiService.back.get('onboarding.list', routeOptions);
            if (response.success) {
                this.onboardingRecords = response.data || [];
                this.totalPages = Math.max(1, Math.ceil(response.count / 20));
                this.updatePageNumbers();
            }
            else {
                this.notifyService.notify(response.error || 'Failed to load onboarding data', 'error');
            }
        }
        catch (error) {
            console.error('Error loading onboarding data:', error);
            this.notifyService.notify('Failed to load onboarding data', 'error');
        }
        finally {
            this.loading = false;
        }
    }
    updatePageNumbers() {
        this.pageNumbers = [];
        const maxVisible = 5;
        const start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
        const end = Math.min(this.totalPages, start + maxVisible - 1);
        for (let i = start; i <= end; i++) {
            this.pageNumbers.push(i);
        }
    }
    getStatusBadge(status) {
        const statusClasses = {
            'in_progress': 'badge-warning',
            'completed': 'badge-success',
            'abandoned': 'badge-danger'
        };
        const statusTexts = {
            'in_progress': 'In Progress',
            'completed': 'Completed',
            'abandoned': 'Abandoned'
        };
        const badgeClass = statusClasses[status] || 'badge-secondary';
        const statusText = statusTexts[status] || status;
        return `<span class="badge ${badgeClass}">${statusText}</span>`;
    }
    getProgressPercentage(record) {
        if (record.status === 'completed')
            return 100;
        if (record.status === 'in_progress')
            return 50;
        return 0;
    }
    formatDate(date, format) {
        return console_1.DateUtils.create(date).format(format);
    }
    startOnboarding() {
        component_1.SiteMenu.goto.bind(this)('/onboarding/pick');
    }
    viewRecord(id) {
        component_1.SiteMenu.goto.bind(this)(`/onboarding/${id}`);
    }
    editRecord(id) {
        component_1.SiteMenu.goto.bind(this)(`/onboarding/wizard/${id}`);
    }
    navigateToAdd() {
        component_1.SiteMenu.goto.bind(this)('/onboarding/pick');
    }
    goToAvatar(id, e) {
        e.preventDefault();
        console.log(`Navigating to avatar with ID: ${id}`);
        component_1.SiteMenu.goto.bind(this)(`/avatar/preview/${id}`);
    }
    async deleteRecord(id) {
        if (!await this.popupService.confirm('Are you sure you want to delete this onboarding record?')) {
            return false;
        }
        try {
            this.loading = true;
            const response = await this.apiService.back.delete('onboarding.delete', { routeParams: { id } });
            if (response.success) {
                // Remove the item from the local list
                this.onboardingRecords = this.onboardingRecords.filter(r => String(r.id) !== id);
                this.notifyService.notify('Onboarding record deleted successfully', 'info');
                this.loadData();
                return true;
            }
            else {
                this.notifyService.notify(response.error || 'Failed to delete onboarding record', 'error');
                return false;
            }
        }
        catch (error) {
            console.error('Error deleting onboarding record:', error);
            this.notifyService.notify('Failed to delete onboarding record', 'error');
            return false;
        }
        finally {
            this.loading = false;
        }
    }
    goToPage(page) {
        if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
            this.currentPage = page;
            this.loadData();
        }
    }
    previousPage() {
        if (this.currentPage > 1) {
            this.goToPage(this.currentPage - 1);
        }
    }
    nextPage() {
        if (this.currentPage < this.totalPages) {
            this.goToPage(this.currentPage + 1);
        }
    }
    canEdit(onboarding) {
        var _a;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        if (isSuperAdmin)
            return true;
        // Always allow creators to edit their onboarding records
        if (this.isUserOwnerOrCreator(onboarding))
            return true;
        // Otherwise check global permission
        return this.canEditGlobal;
    }
    canDelete(onboarding) {
        var _a;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        if (isSuperAdmin)
            return true;
        // Always allow creators to delete their onboarding records
        if (this.isUserOwnerOrCreator(onboarding))
            return true;
        // Otherwise check global permission
        return this.canDeleteGlobal;
    }
    isUserOwnerOrCreator(onboarding) {
        var _a;
        const currentUserId = component_2.DefaultLayout.USER.id;
        const onboardingOwnerId = onboarding.owner ? onboarding.owner : null;
        const onboardingCreatorId = ((_a = onboarding.user) === null || _a === void 0 ? void 0 : _a.id) ? onboarding.user.id : null; // user is creator
        return onboardingOwnerId === currentUserId || onboardingCreatorId === currentUserId;
    }
};
exports.OnboardingUserListComponent = OnboardingUserListComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingUserListComponent.prototype, "onboardingRecords", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingUserListComponent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingUserListComponent.prototype, "canAdd", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingUserListComponent.prototype, "canEditGlobal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingUserListComponent.prototype, "canDeleteGlobal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], OnboardingUserListComponent.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], OnboardingUserListComponent.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingUserListComponent.prototype, "pageNumbers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingUserListComponent.prototype, "faqHeaders", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingUserListComponent.prototype, "faqExpandedItems", void 0);
exports.OnboardingUserListComponent = OnboardingUserListComponent = __decorate([
    (0, client_1.RWSView)('onboarding-user-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], OnboardingUserListComponent);
OnboardingUserListComponent.defineComponent();
